export const columnsDataComplex = [
  {
    Header: "Game Name",
    accessor: "appName",
  },
  {
    Header: "Platform",
    accessor: "platformId",
  },
  {
    Header: "Title",
    accessor: "title",
  },
  {
    Header: "Image",
    accessor: "imageUrl",
  },
  {
    Header: "Scheduled At",
    accessor: "scheduledAt",
  },
  {
    Header: "EDIT",
    accessor: "edit",
  },
  {
    Header: "DELETE",
    accessor: "delete",
  },
];
